$(document).ready(function() {
  'use strict';
	
	var handle_svg_zoom = function($svg_container) {
			
		if($svg_container.length) {
			
			var svg = $svg_container.find("svg");
			if(svg[0]) {
				
				var beforePan = function(oldPan, newPan) {
					
					var sizes = this.getSizes();
					
					var stopHorizontal = false;
					var stopVertical = false;
					var gutterWidth = sizes.width;
					var gutterHeight = sizes.height;
					
					// Computed variables;
					var leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth;
					var rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom);
					var topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight;
					var bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom);
					
					var customPan = {
						x: Math.max(leftLimit, Math.min(rightLimit, newPan.x)),
						y: Math.max(topLimit, Math.min(bottomLimit, newPan.y))
					};
					
					return customPan;
				};
								
				var $svgPanZoom = svgPanZoom(svg[0], {
					//viewportSelector: svg,
					panEnabled: true,
					controlIconsEnabled: false, 
					zoomEnabled: true, 
					dblClickZoomEnabled: false, 
					mouseWheelZoomEnabled: true, 
					preventMouseEventsDefault: true, 
					zoomScaleSensitivity: 0.05, 
					minZoom: 1, 
					maxZoom: 2, 
					fit: false, 
					contain: true, 
					center: true, 
					refreshRate: 'auto', 
					beforeZoom: function(){}, 
					onZoom: function(){}, 
					beforePan: beforePan, 
					onPan: function(){}, 
					//customEventsHandler: {}, 
					//eventsListenerElement: null
				});
				
				$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){
					setTimeout(function() {
						$svgPanZoom.contain();
						$svgPanZoom.center();
						$svgPanZoom.resize();
						$svgPanZoom.resetPan();
						$svgPanZoom.resetZoom();
					}, 300);
				});
				
				$svg_container.find(".svg-controls .zoom-in").on("click", function(e) {
					e.preventDefault();
					$svgPanZoom.zoomIn();
				});

				$svg_container.find(".svg-controls .zoom-out").on("click", function(e) {
					e.preventDefault();
					$svgPanZoom.zoomOut();
				});

				$svg_container.find(".svg-controls .reset").on("click", function(e) {
					e.preventDefault();
					$svgPanZoom.resetZoom();
				});
			
				return $svgPanZoom;
			}
			
		}

		return false;	
	};
	
	var $svgPanZoom;
	var $svg_container = $(".svg-container");
	var $slick_container = $(".slick-container");
	
	if($slick_container.length) {
		
		$svg_container = $(".slick-container .slick-active .svg-container");
		$svgPanZoom = handle_svg_zoom($svg_container);
				
		$slick_container.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			if($svgPanZoom !== false) {
				$svgPanZoom.destroy();
				var $nextSlide = $slick_container.find(".slide:eq(" + nextSlide + ")");
				
				$svg_container = $nextSlide.find(".svg-container");
				$svgPanZoom = handle_svg_zoom($svg_container);
			}
		});

		$slick_container.on('afterChange', function(slick, currentSlide){
			
  	});
		
	} else {
		$svgPanZoom = handle_svg_zoom($svg_container);
	}
	
	

	
});